import { IDataTableColumn } from "nsitools-react";
import * as React from "react";

import { ContactGridDto } from "../../../api";
import { useCommonHooks } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { AdvancedSearchTable } from "../../searchTablePage";

export interface IContactSelectorPanelProps {
  onContactSelected: (contact?: ContactGridDto) => void;
  rightElement: React.ReactElement;
}

export const ContactSelectorPanel: React.FunctionComponent<
  IContactSelectorPanelProps
> = ({ onContactSelected, rightElement }) => {
  const { t, apis } = useCommonHooks();

  const columns = React.useMemo<IDataTableColumn<ContactGridDto>[]>(
    () => [
      {
        fieldName: "name",
        header: () => t(ETLCodes.Name),
      },
      {
        fieldName: "firstName",
        header: () => t(ETLCodes.FirstName),
      },
      {
        fieldName: "email",
        header: () => t(ETLCodes.Email),
      },
      {
        fieldName: "nationalRegistrationNumber",
        header: () => t(ETLCodes.NationalRegistrationNumber),
      },
    ],
    [t]
  );

  const search = React.useCallback(
    (sObj: any) => {
      return apis.contacts.baseSearch(sObj);
    },
    [apis.contacts]
  );

  const getCriteriasFunction = React.useCallback(() => {
    return apis.contacts.getSearchCriterias(true);
  }, [apis.contacts]);

  return (
    <AdvancedSearchTable
      searchFunction={search}
      getCriteriasFunction={getCriteriasFunction}
      columns={columns}
      sortKeys={{ name: "ASC" }}
      storageMode="none"
      onRowClick={(item: ContactGridDto) => onContactSelected(item)}
      rightElement={rightElement}
    />
  );
};
